import { ActionTree } from "vuex";
import {
  RootState,
  ShoppingListState,
  ShoppoingListUpdateItem,
  ShoppingListFavoriteFoodList,
  ShoppingListRecommendationParameter,
  ShoppingListCategorySeachParameter,
  ShoppingListRegistListItem,
  ShoppingListSearchFoodResultList,
  ShoppingListAppendFoodsCategoryListItem,
  ShoppingListAppendRegistingListItem
} from "@/types/shoppingList";
import store from "@/store";
import apiClient from "@/client/api-client";
import { API_URL_SHOPPING_LIST, API_URL_PANTRY } from "@/const/api-const";
import { 
  writeShoppingList
} from "@/model/storage"
import NativeClient from "@/client/native-client";

const actions: ActionTree<ShoppingListState, RootState> = {
  // 買い物リスト取得
  getFoodList: async ({ commit }) => {
    NativeClient.sendDebugLog("Action.ts getFoodList start")
    const res = await apiClient.get(API_URL_SHOPPING_LIST.FOODS_LIST);
    NativeClient.sendDebugLog("Action.ts getFoodList response = " + JSON.stringify(res.data));

    // ストレージに格納
    const jsonString = JSON.stringify(res.data);
    writeShoppingList(jsonString);

    // 更新
    commit("updateFoodList", res.data);
  },
  // 食品提案
  getRecommendationList: async ({ commit }, parameter: ShoppingListRecommendationParameter) => {
    const numberOfRecommendation = 3;
    let checekdIdListString = "";
    let uncheckedIdListString = "";
    for (const id of parameter.checkedIds) {
      checekdIdListString = checekdIdListString + String(id) + " ";
    }
    // 末尾の空白を消去
    checekdIdListString = checekdIdListString.slice(0, -1);
    for (const id of parameter.uncheckedIds) {
      uncheckedIdListString = uncheckedIdListString + String(id) + " ";
    }
    // 末尾の空白を消去
    uncheckedIdListString = uncheckedIdListString.slice(0, -1);

    const res = await apiClient.get(API_URL_SHOPPING_LIST.FOODS_RECOMMENDATION, {
      params: {
        pattern: "shopping",
        refresh: parameter.refresh,
        checkedShoppingFoods: checekdIdListString,
        uncheckedShoppingFoods: uncheckedIdListString,
        row: numberOfRecommendation
      }
    });

    NativeClient.sendDebugLog("Acrtion.ts getRecommendationList res.data = " + JSON.stringify(res.data));

    // 保存する
    commit("updateRecommendationList", res.data);
  },
  updateFoodCheck: async ({commit}, info: ShoppoingListUpdateItem) => {
    const apiPath = API_URL_SHOPPING_LIST.FOODS_CHECK_UPDATE.replace("$foodId", info.id.toString());
    const checked = info.isChecked;
    const res = await apiClient.put(apiPath, { checked });
    NativeClient.sendDebugLog("Action.ts updateFoodCheck response = " + JSON.stringify(res.data));

    // ストレージに格納
    const jsonString = JSON.stringify(res.data);
    writeShoppingList(jsonString);

    // 買い物リストがレスポンスなので、保存する
    commit("updateFoodList", res.data);
  },
  deleteFood: async ({ commit }, id: number) => {
    const apiPath = API_URL_SHOPPING_LIST.FOODS_DELETE.replace("$foodId", id.toString());
    const res = await apiClient.delete(apiPath);
    if (res != undefined && res != null && res.data != null) {
      NativeClient.sendDebugLog("Acrtion.ts deleteFood res.data = " + JSON.stringify(res.data));
    } else {
      NativeClient.sendDebugLog("Acrtion.ts deleteFood res.data is nothing");
    }
  },
  appendToFavorite: async ({ commit }, foodId: number) => {
    NativeClient.sendDebugLog("Acrtion.ts appendToFavorite foodId = " + foodId);
    const res = await apiClient.post(API_URL_SHOPPING_LIST.FOODS_APPEND_FAVORITE, { foodId });
    if (res != undefined && res != null && res.data != null) {
      NativeClient.sendDebugLog("Acrtion.ts appendToFavorite res.data = " + JSON.stringify(res.data));
    } else {
      NativeClient.sendDebugLog("Acrtion.ts appendToFavorite res.data is nothing");
    }
  },
  clearCheckedItems: async ({ commit }) => {
    const res = await apiClient.delete(API_URL_SHOPPING_LIST.FOODS_CHECK_CLEAR);
    if (res != undefined && res != null && res.data != null) {
      NativeClient.sendDebugLog("Acrtion.ts clearCheckedItems res.data = " + JSON.stringify(res.data));
    } else {
      NativeClient.sendDebugLog("Acrtion.ts clearCheckedItems res.data is nothing");
    }
  },
  // 消費済み
  getConsumedFoodList: async ({ commit }) => {
    const rowOneTime = 50;

    const previous: ShoppingListFavoriteFoodList | null = store.getters["shoppingList/getConsumedFoodList"];

    // 全取得済み判定と今回の取得開始位置
    let startPosition = 0;
    if (previous != null && previous.start != null && previous.totalCount != null) {
      // 前回のデータが存在する
      NativeClient.sendDebugLog("Action.ts getConsumedFoodList start = " + previous.start + ", totalCount = " + previous.totalCount);
      if ((previous.start + rowOneTime >= previous.totalCount) || (previous.foods.length >= previous.totalCount)) {
        // 既に全件取得ずみ
        return;
      }
      startPosition = previous.start + rowOneTime;
    }

    // お気に入り食材
    const res = await apiClient.get(API_URL_SHOPPING_LIST.FOODS_CONSUMED, {
      params: {
        // 取得開始位置（すでに取得済みの場合、取得した件数以降の開始位置を指定）
        start: startPosition,
        // 10件
        row: rowOneTime
      }
    });
    NativeClient.sendDebugLog("Action.ts getConsumedFoodList = " + JSON.stringify(res.data));

    // 保存する
    commit("updateConsumedFoodList", res.data);
  },
  // よく使う
  getRankingList: async ({ commit }) => {
    NativeClient.sendDebugLog("Action.ts getRankingList start")
    const res = await apiClient.get(API_URL_SHOPPING_LIST.FOODS_RANKING);
    NativeClient.sendDebugLog("Action.ts getRankingList = " + JSON.stringify(res.data));
    commit("updateRankingList", res.data);
  },
  // お気に入り検索
  getFavoriteList: async ({ commit }) => {
    const rowOneTime = 50;
    NativeClient.sendDebugLog("Action.ts getFavoriteList start");

    const previous: ShoppingListFavoriteFoodList | null = store.getters["shoppingList/getFavoriteList"];

    // 全取得済み判定と今回の取得開始位置
    let startPosition = 0;
    if (previous != null && previous.start != null && previous.totalCount != null) {
      // 前回のデータが存在する
      NativeClient.sendDebugLog("Action.ts getFavoriteList start = " + previous.start + ", totalCount = " + previous.totalCount);
      if ((previous.start + rowOneTime >= previous.totalCount) || (previous.foods.length >= previous.totalCount)) {
        // 既に全件取得ずみ
        return;
      }
      startPosition = previous.start + rowOneTime;
    }

    // お気に入り食材
    const res = await apiClient.get(API_URL_SHOPPING_LIST.FOODS_FAVORITE, {
      params: {
        // 取得開始位置（すでに取得済みの場合、取得した件数以降の開始位置を指定）
        start: startPosition,
        // 10件
        row: rowOneTime
      }
    });
    NativeClient.sendDebugLog("Action.ts getFavoriteList = " + JSON.stringify(res.data));

    // 保存する
    commit("updateFavoriteList", res.data);
  },
  getSceneCategoryList: async ({ commit }) => {
    NativeClient.sendDebugLog("Action.ts getSceneCategoryList start")
    const res = await apiClient.get(API_URL_SHOPPING_LIST.FOODS_CATEGORIES);
    NativeClient.sendDebugLog("Action.ts getSceneCategoryList response = " +  JSON.stringify(res.data));
    commit("updateSceneCategoryList", res.data);
  },
  // 買い物リスト登録前のチェック記憶
  updateRegistingFoodList: ({ commit }, list: Array<ShoppingListAppendRegistingListItem> | null) => {
    commit("updateRegistingFoodList", list);
  },
  // 買い物リスト登録
  registShoppingList: async ({ commit }, foods: Array<ShoppingListRegistListItem>) => {
    NativeClient.sendDebugLog("Action.ts registShoppingList list = " +  JSON.stringify(foods));
    const res = await apiClient.post(API_URL_SHOPPING_LIST.FOODS_REGIST, {
      foods
    });
    // レスポンスを保存する
    commit("updateRegistResult", res.data);
  },
  // 食品検索
  getSearchResultList: async ({ commit }, keyword: string) => {
    const rowOneTime = 20;

    const previous: ShoppingListSearchFoodResultList | null = store.getters["shoppingList/getSearchResultList"];

    // 全取得済み判定と今回の取得開始位置
    let startPosition = 0;
    if (previous != null) {
      // 前回のデータが存在する
      NativeClient.sendDebugLog("Action.ts getSearchResultList start = " + previous.start + ", totalCount = " + previous.totalCount);
      if (previous.start != null && previous.totalCount != null) {
        if ((previous.start + rowOneTime >= previous.totalCount) || (previous.foods.length >= previous.totalCount)) {
          // 既に全件取得ずみ
          return;
        }
        startPosition = previous.start + rowOneTime;
      } else {
        // 不明なので取得しない
        return;
      }
    }

    // 閲覧履歴
    const res = await apiClient.get(API_URL_SHOPPING_LIST.SEARCH_INGREDIENT, {
      params: {
        // 検索対象
        q: keyword,
        // 取得開始位置（すでに取得済みの場合、取得した件数以降の開始位置を指定）
        start: startPosition,
        // 10件
        row: rowOneTime
      }
    });
    NativeClient.sendDebugLog("Action.ts getIngredientCandidate result start = " + res.data.start + ", totalCount = " + res.data.totalCount);

    // 保存する
    commit("updateSearchResultList", res.data);
  },
  // 検索結果
  updateSearchResultList: ({ commit }, list: ShoppingListSearchFoodResultList | null) => {
    commit("updateSearchResultList", list)
  },
  // 前回選択したsh句品追加画面の食品カテゴリのインデックス
  updateSelectCategoryIndex: ({ commit }, index: number) => {
    commit("updateSelectCategoryIndex", index);
  },
  // 食材追加画面のパラメータのクリア
  clearAppendIngredientParameter: ({ commit }) => {
    NativeClient.sendDebugLog("Action.ts clearAppendIngredientParameter start");
    commit("clearAppendIngredientParameter");
  },
  // 在庫食材取得
  getPantryList: async ({ commit }) => {
    NativeClient.sendDebugLog("Action.ts getPantryList start");
    // パントリー一覧API呼び出し 食材が登録／未登録を確認すれば良いので、パラメータは固定
    const res = await apiClient.get(API_URL_PANTRY.LIST, {
      params: {
        order: "newest",
        start: 0,
        row: 1
      }
    });
    NativeClient.sendDebugLog("Action.ts getPantryList response = " + JSON.stringify(res.data));
    commit("updatePantryList", res.data);
  },
  // 提案食材クリア
  clearRecommendationFoodList: ({ commit}) => {
    NativeClient.sendDebugLog("Action.ts clearRecommendationFoodsList");
    commit("clearRecommendationFoodList");
  }
};

export default actions;

